import { NavbarVerticalItem } from '@siemens/element-ng/navbar-vertical';

export const navbarVerticalItems: NavbarVerticalItem[] = [
    {
        type: 'group',
        label: 'Demo',
        icon: 'element-home',
        children: [
            { type: 'router-link', icon: 'element-image', label: 'Icons', routerLink: 'demo/icons' },
            { type: 'router-link', icon: 'element-code', label: 'Elements', routerLink: 'demo/elements' }
        ]
    }
];
